import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import ManufacturersTable from 'components/settings/ManufacturersTable'
import { manufacturersQueryOptions } from 'hooks/products'

export const Route = createFileRoute('/_auth/_admin/admin/manufacturers')({
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(manufacturersQueryOptions)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Stack gap="xl" mt="xl">
      <ManufacturersTable />
    </Stack>
  )
}
